
import { useStore } from '@/store'
import { computed, defineComponent, onMounted, ref, watch } from 'vue'
import RangeTouch from 'rangetouch'
import { FormActionTypes } from '@/store/modules/form/action-types'

export default defineComponent({
  name: 'Progressbar',
  setup() {
    const store = useStore()
    const currentTab = computed(() => store.getters.currentTab)
    let value = ref(1)
    let min = ref(0)
    let max = ref(12)

    onMounted(() => {
      new RangeTouch('input[type="range"]')
    })

    // prettier-ignore
    watch(() => currentTab.value, (tab) => {
        value.value = tab + 1
      }
    )

    const onChange = (_) => {
      value.value = getClampedValue()
    }

    const onInput = (_) => {
      const val = Math.max(value.value, 1)
      // value.value = val
      store.dispatch(FormActionTypes.SET_CURRENT_TAB, val - 1)
    }

    const getGradient = (_) => {
      let gradient = (getClampedValue() - min.value) / (max.value - min.value)
      return '-webkit-gradient(linear, left top, right top, ' + 'color-stop(' + gradient + ', #d7006a), ' + 'color-stop(' + gradient + ', #eeeeee)' + ')'
    }

    function getClampedValue() {
      return Math.min(Math.max(value.value, 1), max.value)
    }

    const onTouchend = () => {
      setTimeout(() => {
        value.value = Math.max(value.value, 1)
      }, 100)
    }

    return {
      currentTab,
      onChange,
      onInput,
      onTouchend,
      value,
      getGradient,
      min,
      max
    }
  }
})
